let isLogin = false;
let toLogin = () => {};

if (window.FEGORender) {
    const {
        common,
        store: { variable }
    } = window.FEGORender;

    // 是否已登录
    isLogin = !!variable.data.UID;
    // 去登录
    toLogin = (ctx) =>
        common.behavior.runBehaviour(ctx, {
            type: 'login',
            value: location.href,
            withQuery: true
        });
}

function getEntity() {
    // 获取插件配置
    return window._extra['tool-date-formatter']?.options?.entity;
}

export { isLogin, toLogin, getEntity };
